import { combineReducers } from "redux";
import projectReducer from "./projectReducer";
import OPAReducer from "./OPAReducer";
import AddNewProjectReducer from "./AddNewProjectReducer";
import commonReducer from "./commonReducer";
import ShipDocumentReducer from "./ShipDocumentReducer";
import YardDocumentReducer from "./YardDocumentReducer";
import YardAuditReportReducer from "./YardAuditReportReducer";
import CorrectiveActionsReducer from "./CorrectiveActionsReducer"
import PBDReducer from "./PBDReducer";
import WPReducer from "./WPReducer";
import TrainingModuleReducer from "./TrainingModuleReducer"
import DWPRReducer from "./DWPRReducer";
import DMSReducer from "./DMSReducer";
import PCPReducer from "./PCPReducer";
import MOMReducer from "./MOMReducer";
import SOCReducer from "./SOCReducer";
import IRReducer from "./IRReducer";
import MasterDataReducer from "./MasterDataReducer";
import IADOSReducer from "./IADOSReducer";
import DispositionReducer from "./DispositionReducer";
import TrainingPlanReducer from "./TrainingPlanReducer";
import UserReducer from "./UserReducer";
import DismantlingReducer from "./DismantlingReducer";
import SectionDivisionReducer from "./SectionDivisionReducer";
import BlockDivisionReducer from "./BlockDivisionReducer";
import ProjectMasterDataReducer from "./ProjectMasterDataReducer";

const rootReducer = combineReducers({
    projectReducer,
    AddNewProjectReducer,
    OPAReducer,
    commonReducer,
    ShipDocumentReducer,
    YardDocumentReducer,
    YardAuditReportReducer,
    CorrectiveActionsReducer,
    PBDReducer,
    WPReducer,
    TrainingModuleReducer,
    DWPRReducer,
    PCPReducer,
    DMSReducer,
    MOMReducer,
    SOCReducer,
    IRReducer,
    MasterDataReducer,
    IADOSReducer,
    DispositionReducer,
    TrainingPlanReducer,
    UserReducer,
    DismantlingReducer,
    SectionDivisionReducer,
    BlockDivisionReducer,
    ProjectMasterDataReducer,
});

export default rootReducer;
